import { DigitalJourneyBodyShop } from "types/DigitalJourneySession";

import client from "./client";

export type BodyShopsResponse = Array<DigitalJourneyBodyShop>;

export const getBodyShopsByPostCode = (postCode: string): Promise<BodyShopsResponse> =>
  client.get(`/session/digitalJourney/bodyShops?postalCode=${postCode}`).then(({ data }) => data);
